import React from 'react';

// Penalty callout — shown above the daily insight when the coach has
// scheduled make-up workout(s) for blowing past the calorie ceiling.
// Tap forwards to the recommendations modal (where the user can read
// the full breakdown and find the workout in their feed).
const PenaltyCallout = ({ callout, onClick }) => {
  if (!callout || !Array.isArray(callout.penalties) || callout.penalties.length === 0) return null;

  const isOverdue = (callout.overdue_count || 0) > 0;
  const total = Number(callout.total_surplus_calories) || 0;
  const count = callout.penalties.length;

  // Single vs multi headline.
  const headline = count === 1
    ? <>You owe a <strong>{total} kcal</strong> burn from your calorie debt.</>
    : <>You have <strong>{count}</strong> open calorie-debt workouts <strong>({total} kcal total)</strong>.</>;

  // Closest deadline drives the meta line.
  const next = [...callout.penalties].sort((a, b) =>
    new Date(a.due_at || 0) - new Date(b.due_at || 0)
  )[0];
  let metaText = '';
  if (next?.due_at) {
    const dueMs = new Date(next.due_at).getTime() - Date.now();
    if (dueMs <= 0) {
      metaText = 'Overdue — costs consistency points until cleared.';
    } else {
      const days = Math.ceil(dueMs / (1000 * 60 * 60 * 24));
      metaText = days <= 1
        ? 'Due by end of day — clear it to keep your streak.'
        : `${days} days to clear it before it costs consistency points.`;
    }
  }

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick();
  };

  return (
    <div
      className={`penalty-callout ${isOverdue ? 'overdue' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(e); }}
    >
      <div className="penalty-callout-icon">{isOverdue ? '⚠️' : '🔥'}</div>
      <div className="penalty-callout-body">
        <p className="penalty-callout-title">{isOverdue ? 'Overdue calorie debt' : 'Calorie debt due'}</p>
        <p className="penalty-callout-headline">{headline}</p>
        {metaText && <div className="penalty-callout-meta">{metaText}</div>}
      </div>
      <div className="penalty-callout-arrow">→</div>
    </div>
  );
};

export default PenaltyCallout;
